export const SECTION_PADDING = '20px'
